import { BRAND_NAME, LEGAL_NAME } from "@/config/business";
import { ORGANIZATION_ID } from "@/lib/seoPolicy";

export function articleAuthorSchema(name: string) {
  const author = name.trim();
  if (!author || author === BRAND_NAME || author === LEGAL_NAME) return { "@id": ORGANIZATION_ID };
  return { "@type": "Person", name: author };
}